import { createAction } from 'redux-actions'
import {
  CHANGE_PASSWORD,
  CHANGE_PASSWORD_FAILED,
  CHANGE_PASSWORD_SUCCEEDED,
  UPDATE_PASSWORD,
  UPDATE_PASSWORD_FAILED,
  UPDATE_PASSWORD_SUCCEEDED,
  SEND_PASSWORD_RESET_LINK,
  SEND_PASSWORD_RESET_LINK_FAILED,
  SEND_PASSWORD_RESET_LINK_SUCCEEDED,
  CLEAR_UPDATE_PASSWORD_ERROR,
} from 'Redux/Types/PasswordResetTypes'

export const sendPasswordResetLink = createAction(SEND_PASSWORD_RESET_LINK)
export const sendPasswordResetLinkFailed = createAction(SEND_PASSWORD_RESET_LINK_FAILED)
export const sendPasswordResetLinkSucceeded = createAction(SEND_PASSWORD_RESET_LINK_SUCCEEDED)

export const changePassword = createAction(CHANGE_PASSWORD)
export const changePasswordFailed = createAction(CHANGE_PASSWORD_FAILED)
export const changePasswordSucceeded = createAction(CHANGE_PASSWORD_SUCCEEDED)

export const updatePassword = createAction(UPDATE_PASSWORD)
export const updatePasswordFailed = createAction(UPDATE_PASSWORD_FAILED)
export const updatePasswordSuccess = createAction(UPDATE_PASSWORD_SUCCEEDED)
export const clearUpdatePasswordError = createAction(CLEAR_UPDATE_PASSWORD_ERROR)
